<template>
  <v-container class="py-0 my-0">
    <PageHeader :title="pageTitle" :path="goToPath" />
    <!-- Controles superiores -->
    <v-row align="center">
      <v-col :cols="isMobile ? 12 : 6" :class="isMobile ? 'pb-2' : ''">
        <v-select
          label="Grupos de usuarios"
          v-model="selectedGrupo"
          variant="outlined"
          density="compact"
          @update:model-value="loadPermisos()"
          :items="gruposList"
          return-object
          item-value="id"
          item-title="value"
          clearable
          prepend-inner-icon="mdi-account-group"
          id="v-select-gruposList"
        />
      </v-col>
      <v-col
        :cols="isMobile ? 6 : 3"
        :class="isMobile ? 'pt-0' : ''"
        class="d-flex align-center pb-8"
      >
        <div
          class="d-flex ga-2 w-100"
          :class="'justify-start'"
        >
          <v-btn
            color="success"
            variant="flat"
            size="default"
            :loading="isSavingActualizar"
            :disabled="!selectedGrupo || isLoadingItems"
            prepend-icon="mdi-content-save"
            @click="savePermisosGrupo"
          >
            Guardar
          </v-btn>
        </div>
      </v-col>
      <v-col
        :cols="isMobile ? 6 : 3"
        :class="isMobile ? 'pt-0' : ''"
        class="d-flex align-center pb-8"
      >
        <div
          class="d-flex ga-2 w-100"
          :class="isMobile ? 'justify-end' : 'justify-end'"
        >
          <v-btn
            color="primary"
            variant="flat"
            size="default"
            prepend-icon="mdi-plus"
            @click="openEditDialog()"
          >
            Nuevo
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <!-- Lista de permisos -->
    <v-card elevation="1">
      <PermisoList
        :allPermisos="permisosList"
        :isLoadingItems="isLoadingItems"
        :disableCheck="!selectedGrupo"
        @emitSeleccionarPermiso="seleccionarPermiso"
        @emitOpenEditDialog="openEditDialog"
        @emitOpenDeleteDialog="openDeleteDialog"
      />
    </v-card>

    <v-dialog
      :max-width="isMobile ? '95%' : '30%'"
      v-model="dialogDelete"
      persistent
    >
      <DeleteDialog
        v-if="dialogDelete"
        title="permiso"
        :isLoading="isLoadingDelete"
        :subtitle="deleteSubtitle"
        @eliminar-confirmado="borrarPermiso"
        @eliminar-cancelado="closeDeleteDialog"
      />
    </v-dialog>
    <v-dialog
      :max-width="isMobile ? '95%' : '50%'"
      v-model="editPermisoDialog"
      persistent
    >
      <EditPermisos
        :permisoItem="permisoItem"
        :permisosListItems="permisosListItems"
        @closeDialog="closeEditDialog"
        @reloadPermisos="loadPermisos()"
      />
    </v-dialog>
  </v-container>
</template>

<script>
import PageHeader from "@/components/layout/PageHeader.vue";
import PermisoList from "@/components/modules/permisos/PermisoList.vue";
import EditPermisos from "@/components/modules/permisos/EditPermisos.vue";
import DeleteDialog from "@/components/shared/DeleteDialog.vue";
import enums from "@/utils/enums/index";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "permisos-page",
  components: {
    PageHeader,
    PermisoList,
    DeleteDialog,
    EditPermisos,
  },
  data() {
    return {
      pageTitle: enums.permises.PERMISOS.name,
      goToPath: enums.permises.HOME.path,
      permisosList: [],
      selectedGrupo: null,
      gruposList: [],
      editPermisoDialog: false,
      dialogDelete: false,
      deleteSubtitle: "",
      idToDelete: null,
      isLoadingDelete: false,
      isLoadingItems: false,
      isSavingActualizar: false,
      permisosListItems: [],
    };
  },
  computed: {
    ...mapGetters({
      permisos: "menu/permisos",
      isMobile: "menu/isMobile",
    }),
  },
  created() {
    this.$store.dispatch("user/changeAppLoading", {
      status: false,
      text: "",
    });
    this.setGrupos();
  },
  methods: {
    ...mapActions({
      getPermisos: "permisos/getPermisos",
      getGruposUsuarios: "taxonomy/getGruposUsuarios",
      deletePermiso: "permisos/deletePermiso",
      savePermisosGrupos: "permisos/savePermisosGrupos",
      setAlert: "user/setAlert",
    }),
    seleccionarPermiso(permisoSeleccionado) {
      permisoSeleccionado.permisoIsFromUserGroup =
        !permisoSeleccionado.permisoIsFromUserGroup;
      if (permisoSeleccionado.permisoPadreId === null)
        this.actualizarHijos(
          permisoSeleccionado,
          permisoSeleccionado.permisoIsFromUserGroup
        );
      else if (
        permisoSeleccionado.permisoPadreId !== null &&
        permisoSeleccionado.permisoIsFromUserGroup == true
      ) {
        this.actualizarPadres(
          permisoSeleccionado,
          permisoSeleccionado.permisoIsFromUserGroup
        );
      }
    },
    actualizarHijos(permiso, valor) {
      permiso.permisoHijos.forEach((hijo) => {
        hijo.permisoIsFromUserGroup = valor;
        if (hijo.permisoHijos.length > 0) {
          this.actualizarHijos(hijo, valor);
        }
      });
    },
    listAllPermisos(permisos) {
      permisos.forEach((item) => {
        this.permisosListItems.push(item);
        if (item.permisoHijos.length > 0) {
          this.listAllPermisos(item.permisoHijos);
        }
      });
      return this.permisosListItems;
    },
    actualizarPadres(permiso, valor) {
      const padre = this.permisosListItems.find(
        (x) => permiso.permisoPadreId === x.permisoId
      );
      padre.permisoIsFromUserGroup = valor;
      if (padre.permisoPadreId !== null) this.actualizarPadres(padre, valor);
    },
    async setGrupos() {
      await this.loadCombo();
      if (this.gruposList?.length > 0) {
        this.selectedGrupo = this.gruposList[0];
        this.loadPermisos();
      }
    },
    async loadCombo() {
      this.gruposList = await this.getGruposUsuarios();
    },
    async loadPermisos() {
      if (!this.selectedGrupo) return;
      try {
        this.isLoadingItems = true;
        this.permisosList = await this.getPermisos(this.selectedGrupo.id);
        this.permisosListItems = [];
        this.listAllPermisos(this.permisosList);
      } catch (error) {
        console.error(error);
      }
      this.isLoadingItems = false;
    },

    openDeleteDialog(id, nombre) {
      this.deleteSubtitle = `¿Desea eliminar el permiso "${nombre}"?`;
      this.dialogDelete = true;
      this.idToDelete = id;
    },
    closeDeleteDialog() {
      this.dialogDelete = false;
    },
    async borrarPermiso() {
      this.isLoadingDelete = true;
      try {
        const resp = await this.deletePermiso(this.idToDelete);
        if (resp?.status == 200) {
          this.setAlert({
            type: "success",
            message: "Permiso eliminado con éxito ",
          });
          this.dialogDelete = false;
          this.loadPermisos();
        }
      } catch (error) {
        console.error(error);
      }
      this.isLoadingDelete = false;
    },
    buscarPermisosSeleccionados(permisos) {
      let permisosIds = [];
      permisos.forEach((permiso) => {
        if (permiso.permisoIsFromUserGroup) {
          permisosIds.push(permiso.permisoId);
        }
        if (permiso.permisoHijos.length > 0) {
          permisosIds = permisosIds.concat(
            this.buscarPermisosSeleccionados(permiso.permisoHijos)
          );
        }
      });
      return permisosIds;
    },
    async savePermisosGrupo() {
      this.isSavingActualizar = true;
      let permisosIds = [];
      permisosIds = this.buscarPermisosSeleccionados(this.permisosList);
      const payload = {
        PermisosId: permisosIds,
        grupoUsuId: this.selectedGrupo.id,
      };

      try {
        const resp = await this.savePermisosGrupos(payload);
        if (resp?.status == 200) {
          this.setAlert({
            type: "success",
            message: "Guardado con éxito ",
          });
        }
      } catch (error) {
        console.error(error);
      }
      this.isSavingActualizar = false;
    },
    openEditDialog(item) {
      this.editPermisoDialog = true;
      this.permisoItem = item;
    },
    closeEditDialog() {
      this.editPermisoDialog = false;
      this.loadPermisos();
    },
  },
};
</script>

<style scoped>
/* Espaciado para botones */
.ga-2 {
  gap: 8px;
}

/* Asegurar que el ancho sea completo */
.w-100 {
  width: 100%;
}
</style>
